module.exports = __webpack_public_path__ + "img/web-design.05aa9764.png";